import { Modal, OfficeButton } from "components";
import { useAppSearch } from "_graphql/cache/auth";

import _ from "lodash";
import { approveKEKEndorsementOffer } from "_graphql/kek/mutation/index.kek";
import toast from "react-hot-toast";
import { useFormik } from "formik";
import { useMutation } from "@apollo/client";
import { useOfferComments } from "hooks/data/use-offer-comments";
import { withPermissions, wrapClick } from "utils";
import { useKEKEndorsement } from "hooks/data/use-endorsement";
import ApproveEndorsementOffer from "components/forms/approve-endorsement-offer";
import {
  ApproveKEKEndorsementOffer,
  ApproveKEKEndorsementOfferVariables,
} from "_graphql/kek/mutation/__generated__/ApproveKEKEndorsementOffer";

export default function ApproveOfferContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const searchParam = useAppSearch();
  const { endorsement, loading } = useKEKEndorsement({
    offerEndorsementId: searchParam?.id || "",
  });
  const { comments, loading: loadingComments } = useOfferComments({
    offerId: searchParam?.id || "",
  });
  const [setStatus, { loading: settingStatus }] = useMutation<
    ApproveKEKEndorsementOffer,
    ApproveKEKEndorsementOfferVariables
  >(approveKEKEndorsementOffer, {
    refetchQueries: ["GetKEKEndorsements"],
  });
  const form = useFormik<any>({
    initialValues: {
      status: "",
      message: "",
    },
    onSubmit: async (variables) => {
      setStatus({
        variables: {
          documentMessage: [variables?.message],
          offerId: endorsement?.offer?.offer_id || "",
          offerEndorsementId: searchParam?.id || "",
          approvalStatus: variables?.status || "",
        },
      })
        .then(() => {
          toast.success("Endorsement status changed successfully!");
          setOpen?.(false);
        })
        .catch((error) => {
          console.error("Error changing endorsement status:", error);
          toast.error("Failed to change endorsement status.");
        });
    },
    onReset: () => {
      setOpen(false);
    },
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading || loadingComments}
      title="Approve Endorsement Offer"
      description="Review and approve the endorsement offer details before proceeding."
      renderActions={() => (
        <>
          {withPermissions([
            "*:*",
            "endorsements:*",
            "endorsements:manage",
            "endorsements:approve",
          ])(
            <OfficeButton
              disabled={settingStatus}
              onClick={wrapClick(form.handleSubmit)}
            >
              {settingStatus ? "Submitting..." : "Submit"}
            </OfficeButton>
          )}
        </>
      )}
    >
      <ApproveEndorsementOffer
        form={form}
        endorsement={endorsement}
        comments={comments}
      />
    </Modal>
  );
}
